import React from "react";
import arafat from '../../assets/photos/hacc/arafat.jpg'
import arafatCadirlari from '../../assets/photos/hacc/arafat-cadirlari.jpg';
import babaArafatCadirinda from '../../assets/photos/hacc/baba-arafat-cadiri.jpg';
import MuhammedSddkMeymeni from '../../assets/photos/portraits//muhammed-siddik-meymeni.jpg';
import MihriAliSuleyman from '../../assets/photos/portraits//mihri-ali-suleyman.jpg';
import MahmutSamiKirazoglu from '../../assets/photos/portraits//mahmut-sami-kirazoglu.jpg';
import NecatiOzturk from '../../assets/photos/portraits//necati-ozturk.jpg';
import GonenliMehmetEfendi from '../../assets/photos/portraits/gonenli-mehmet-efendi.jpg';
import HafizNusretYesilcay from '../../assets/photos/portraits/hafiz-nusret-yesilcay.jpg';
import AbdurrahmanSerefYazici from '../../assets/photos/portraits/abdurrahman-seref-guzelyazici.jpg';
import HaciHafizFikriAksoy from '../../assets/photos/portraits/haci-hafiz-fikri-aksoy.jpg';
import HafizCevatAksoy from '../../assets/photos/portraits/hafiz-cevat-aksoy-2.jpg';
import ZekiAltun from '../../assets/photos/portraits/zeki-altun.jpg';
import { PhotoColumn } from "../../components/photo-column";
import hicazHavaYollari from '../../assets/photos/hacc/hicaz-yollari.jpg';
import mekkeKapisi from '../../assets/photos/hacc/mekke-kapisi-rahle.jpg';
import kabe from '../../assets/photos/hacc/eski-kabe.jpg';
import kabePanorama from '../../assets/photos/hacc/kabe-panorama.jpg';
import ilkZemzemKuyusu from '../../assets/photos/hacc/ilk-zemzem-kuyusu.jpg'
import mikatMahali from '../../assets/photos/hacc/mikat-mahalli.jpg'
import tavafBaslangicNoktasi from '../../assets/photos/hacc/tavaf-baslangic-noktasi.jpg';
import kabeSaftlar from '../../assets/photos/hacc/kabe-savt.jpg';
import multezemKapisi from '../../assets/photos/hacc/multezem-kapisi.jpg';
import safaTepesi from '../../assets/photos/hacc/safa-tepesi.jpg';
import merveTepesi from '../../assets/photos/hacc/merve-tepesi.jpg'
import hacerulEsved from '../../assets/photos/hacc/hacerul-esved.jpg';
import muzdelifeCadirlari from '../../assets/photos/hacc/muzdelife-cadirlari.jpg';
import minaCadirlari from '../../assets/photos/hacc/mina-cadirlari.jpg';
import seytanTaslama from '../../assets/photos/hacc/seytan-taslama.jpg';
import kurban from '../../assets/photos/hacc/kurban-koc.jpg';
import kitabe from '../../assets/photos/hacc/kitabe.jpg'
import makamiIbrahimAll from '../../assets/photos/hacc/makami-ibrahim-all.jpg'
import "./hajj.scss";

const Hajj = () => {
    // müzdelife cadiri foto degistir
    return (
        <section className="hajj-section">
            <h3 className="section-title">BİR DERVİŞİN HİCAZ YOLUNDAKİ 28 YILLIK NOT DEFTERİNDEN...</h3>


            <article>
                <p>
                    Hacca veya umreye gidecek her Mü’min ve Mü’mineyi
                    tatlı bir heyecan sarar. Öyle ya, bu sıradan bir yolculuk değildir.
                    Kainatın Sultanının, Malikinin, Hakiminin davetlisi olmak
                    ve Allahu Azimüşşan’ın evini ziyaret et mek her kula
                    nasip olmaz.
                </p>
                <p>
                    Allahu Azimüşşan elbette mekandan münezzehtir.
                    Her yerde hazır ve nazırdır, insanlara şah damarlarından
                    daha yakındır. İşte Kâbe bu sırrın da en mükemmel
                    şekil de hissedildiği, Cenab-ı Hakk’ın binbir isminin
                    azam dere cede tecelli ettiği, kulluk şuurunun tam manasıyla
                    idrak edildiği, İlahî davetin bir nevi kabul merasiminin
                    gerçek leştiği bir mekandır.
                </p>
                <p>
                    Bir kimse dünyevî makam sahibi bir zatın huzuruna
                    çıktığında bile heyecanlanır. Mü’minse namaz gibi bir
                    nevi mi’rac olan muazzam hadisede yüzünü çevirdiği beden
                    kıblesi olan Kâbe’ye, bir diğer adıyla ruh kıblesi olan
                    Allah’a gidecek, Peygamber Efendimizin de (S.A.V.) öpüp
                    meshettiği Hacerü’l Esved’i ya öpüp, ya istilam ederek
                    “Ehl-i Tevhid”den oluşun şevkiyle tıpkı bir Mevlevi dervişi
                    gibi, tıpkı çekirdeğin etrafındaki moleküller gi bi tavaf etmeye
                    başlayacaktır.
                </p>
                <p>
                    Kâbe’yi tavaf, haccın ve umrenin en mühim rükünlerindendir.
                    Buna diğer rükünler, vacipler ve sünnetler de ilave olacak
                    ve ortaya, hac veya umre yapanın hem dünyasına, hem
                    ahiretine tesir edecek bir ibadetler manzumesi çıkacaktır.
                </p>
                <p>
                    Hac yalnızca İslam’ın beş şartından birinin îfa edilmesiyle
                    “borçtan” kurtuluş hadisesi değildir. Haccın, temel
                    bir farizanın eda edilişinin yanı sıra, pek çok hikmetle ri, gayesi
                    ve esrarı vardır. İşte o hikmetler ve esrarlar bilindiğinde,
                    ona uygun hareket edildiğinde, “Hacı” unvanlı Mü’mindeki
                    muazzam inkılap, dalga dalga İslam toplumuna yayılacaktır.
                </p>
                <p>
                    Allahü Zül’-Celal’e hamd ü sena, Resulüne salavat ve
                    selamdan sonra talib-i didar ve salik-i rah-ı hakikat olan
                    Mü’min kardeşlerime dualar okunup, tarafımdan kendilerine
                    işbu kitab hediye olunmuştur. Zira manevi peder
                    olan bir kimsenin, manevi evladlarıa nasihat edip tavsiyelerde
                    bulunmaktan daha büyük bir hediye olmaz.
                </p>
            </article>
            <h1 className="section-title">Muzaffer Aşki ile Aşk’a Yolculuk Hicaza Davet</h1>
            <article>
                <p>
                    Muzaffer Aşki Hazretleri’ne bir rüya arz etmiştim. Rüyada,
                    bazı zevat-ı âli, Fakiri Rüyada şereflendirmişti. Manevi alemde
                    Rabbim nasib etti; ilk haccımı 1977’de Efendi Hazretleri;
                    “Hicaz’a davet ediliyorsunuz buyurdular. Bu üçüncü haccınız
                    oluyor galiba”, diye buyurarak tebrik ettiler. “Bendenizin
                    ilk haccı olacak inşallah”, deyince “Allahüazimüşşan manada
                    öyle buyuruyor, iki hac sevabı vermiş, bu da üçüncü haccınız”,
                    cevabını verdiler. “Git evine hemen valizini hazırla”, emir
                    buyurunca durumumun müsait olmadığını, maddi imkânımın
                    yetersiz olduğunu arz ettim. “Sana valizini hazırla dedik ya!”,
                    deyince “eyvallah,” dedik.
                </p>
                <p>
                    İkinci gün sahaflara uğradık. Efendimin huzurunda tekrar
                    sohbetle müstefit oluyoruz, hac konusunda herhangi bir gelişme
                    yok. Üçüncü gün Efendi hazretleri yine sohbette iken telefon
                    çaldı. Cağaloğlu Emniyet Sandığı Müdürü telefon etti, bir hacılık
                    döviz var, hacca gidecek biri varsa verelim, der. "Pasapor-
                    tun mevcut mu", dedi. Biz, pasaport hazır değil, dedik. Hemen
                    Efendi, tanıdığı çarşı esnafından tücceran mütebarından Kayserili
                    Ahmet Efendi’ye fakiri gönderdi. O da bizi pasaport ikinci
                    şube Müdürlüğüne, Sadettin Beyefendi’ye götürdü. O zaman
                    pasaport almak epey mesele iken iki günde pasaportumuzu
                    verdiler. Pasaportu alıp dövizi işlettik, aldık. O zaman Türk parasını
                    koruma yasası gereği döviz pasaporta işleniyordu.
                </p>
                <p>
                    Türk hacıların ekseriyeti gitmişti, biz en sona kalmıştık.
                    Bundan üç gün sonra Efendi’nin sahaflardaki kütüphanesine
                    hac için destur almaya gittim. İkindi vakti saat: 16:00 civarında
                    adeta kütüphane bir meşayih meclisi kurulmuştu. Efendim
                    başta olmak üzere Kadiri, Rufai, Mevlevi, Nakşi, Şabani,
                    Uşakî, Bektaşi, Melâmi meşayihi meclistelerdi. Ayrıca milli birlik
                    hükümetinin Başbakanı Ord. Prof. Sadi Irmak, —ki o sıralar
                    Kuran-ı Kerim tefsiri yapmıştı— Tin suresi üzerine sohbette
                    bulunuyordu. Orada hazır bulunan zevat-ı ali fakire hediyeler
                    vererek ihsanda bulundular. O anda adeta heyacandan uçuyordum,
                    o anı tarif etmek zor. İnşaallah Rabbim bunu sizlere
                    de yaşatır. Allahüazimüşşan, burada olduğu gibi Hicaz’da
                    da maddi-manevi çok büyük iltifatlara mazhar etti. Efendi söz
                    olarak “Kabul olunan hacının ismi arzda ve Arşta yazılıyormuş”
                    diye buyurdu.
                </p>
                <p>
                    Mekke delilim Süleyman Sadaka Paşa, Medine delilim
                    Haşim El Kureyşî, hac şeriklerim: Kudemadan Doğan Bey,
                    İstanbul Müftüsü Abdurrahman Şeref Güzelyazıcı, Gönenli
                    Hacı Hafız Mehmet Efendi, Hacı Hafız Fikri Aksoy, Hafız Nusret
                    Yeşilçay, Zeki Altın, İstanbul merkez Vaizi İbrahim Subaşı
                    Hocaefendi ve “Gönül dostumuz Kâbe aşığı” Mustafa Çıtlak
                    Hoca idiler. Gayesi İslam’a ve insana hizmet olan Mustafa Çıtlak
                    Hoca, son vasiyeti olarak evlatlarının da aynı minval üzere
                    olmasını vasiyet buyurmuştu. Öyle bir zevat ile iman zevkini
                    yaşatarak hac yaptık ki, Allah bütün Müslümanlara öyle
                    hac nasip etsin.
                </p>
                <p>
                    Bize manevi desteklerini esirgemeyen, esere hazırlamamız-
                    da yardımcı olanlar: Kâbe müdürü Muhammed Yusuf, Arif Hikmet
                    kütüphanesi müdürü Medineli Ali Ulvi Kurucu efendi, Ravza
                    mimarı Ömer Kirazoğlu, Reis-ül Kurra Muhammed Sıddık, Bilal-i
                    Habeşi Müezzini Mihr Ali, Mekke Medine mescitlerini yapan son
                    devrin Mimar Sinanı olarak anılan Mahmut Kirazoğlu, İhsan Sanabel,
                    Mekke Üniversitesi Dr. Necati Öztürk, Bin Ladin şirketinin müdürü
                    Seyyid Abdullah Qâri, Muzaffer Aşkî Fatiha’larla anıyoruz.
                </p>

                <div className="hacc-photo-column">
                    <PhotoColumn
                        imageSource={NecatiOzturk}
                        imageTitle="Necati Öztürk"
                        figcaptionFirstTitle="Necati Öztürk"
                        className="red-caption"
                    />
                    <PhotoColumn
                        imageSource={MuhammedSddkMeymeni}
                        imageTitle="Muhammed Sıddık El Meymeni"
                        figcaptionFirstTitle="Muhammed Sıddık El Meymeni"
                        className="red-caption"
                    />

                    <PhotoColumn
                        imageSource={HafizCevatAksoy}
                        imageTitle="Hafız Cevat Aksoy"
                        figcaptionFirstTitle="Hafız Cevat Aksoy"
                        className="red-caption"
                    />
                    <PhotoColumn
                        imageSource={MahmutSamiKirazoglu}
                        imageTitle="Mahmut Sami Kirazoğlu"
                        figcaptionFirstTitle="Mahmut Sami Kirazoğlu"
                        className="red-caption"
                    />
                    <PhotoColumn
                        imageSource={GonenliMehmetEfendi}
                        imageTitle="Gönenli Mehmet Efendi"
                        figcaptionFirstTitle="Gönenli Mehmet Efendi"
                        className="red-caption"

                    />
                    <PhotoColumn
                        imageSource={HafizNusretYesilcay}
                        imageTitle="Hafız Nusret Yeşilçay"
                        figcaptionFirstTitle="Hafız Nusret Yeşilçay"
                        className="red-caption"
                    />
                    <PhotoColumn
                        imageSource={AbdurrahmanSerefYazici}
                        imageTitle="Abdurrahman Şeref Yazıcı"
                        figcaptionFirstTitle="Abdurrahman Şeref Yazıcı"
                        className="red-caption"
                    />
                    <PhotoColumn
                        imageSource={ZekiAltun}
                        imageTitle="Zeki Altun"
                        figcaptionFirstTitle="Zeki Altun"
                        className="red-caption"

                    />
                    <PhotoColumn
                        imageSource={MihriAliSuleyman}
                        imageTitle="Mihriali Süleyman"
                        figcaptionFirstTitle="Mihriali Süleyman"
                        className="red-caption"
                    />

                    <PhotoColumn
                        imageSource={HaciHafizFikriAksoy}
                        imageTitle="Hacı Hafız Fikri Aksoy"
                        className="red-caption"
                        figcaptionFirstTitle="Hacı Hafız Fikri Aksoy"
                    />
                </div>
                <p style={{ fontWeight: "bold" }}>
                    1977’de ilk haccımı yaptım. Her yıl hacca ve umreye
                    gidiyoruz. 19 Yıldır hac danışmanlığı yapıyorum. 28 yıldır
                    o mübarek beldelerde hac ile ilgili kendi şahsi tecrübelerim,
                    araştırmalarım ve hacıların sorularına muhatap
                    olmam dolayısı ile böyle bir eserin hazırlanmasının
                    faydalı olacağı zuhur etti.
                </p>
                <p>
                    Hacla ilgili pek çok eser vardı. Hepsi de özenle hazırlanmıştı.
                    Bütün hazırlayanlardan Allah razı olsun. Ama o eserlerde, bizim
                    en çok üzerinde duracağımız hususun üzerinde ya hiç durulmamış,
                    ya çok sathi durulmuştu.
                </p>
                <p>
                    Hacla ilgili fıkhı bilgiler, hacda ve umrede okunabilecek dualar,
                    ziyaret mahalleriyle ilgili bilgiler artık rahatlıkla ulaşılabilecek
                    malûmatlardır.
                </p>
                <p>
                    O mübarek yolculuğa çıkanlara en fazla, haccın ve umrenin
                    âdabı anlatılmalıdır. Âcizane görüşümüz budur. Hacı adayı yolculuğa
                    nasıl hazırlanmalıdır? (Maddî-manevî hazırlık), beraberinde
                    neler götürmelidir? Yolda nasıl davranmalıdır? Arkadaşlarını
                    nasıl seçmeli ve onlarla nasıl diyalog kurmalıdır? Mekke’de ve
                    Medine’de vaktini nasıl değerlendirmelidir? İbadetlerini yaparken
                    nelere dikkat etmelidir? Haccın hikmetine uygun olarak neler
                    yapabilir? Ziyaret mahallerinde neler düşünmeli, neler hayal etmelidir?
                    Hac ve umre vazifesini tamamladıktan sonra nasıl davranmalıdır?
                    Memleketine döndükten sonra yaşayışında ne gibi
                    değişiklikler olacaktır?
                </p>
                <p>
                    İşte bu ve benzeri pek çok sorunun cevapları hacı adayına ve
                    “hacı” unvanını alacak olan o bahtiyar insanlara enine-boyuna
                    anlatılmalıdır. Biz “anafikir” olarak bu düşünceden yola çıktık ve
                    çalışmamızın “temelini” bu düşünce üzerine bina ettik.
                </p>

                <h3 className="section-title">HACC'IN KISIMLARI VE HACC HATIRALARIMIZDAN RESIMLER</h3>

                <div>
                    <p className="hajj-subtitle">1. Haccımız</p>
                    <PhotoColumn
                        imageSource={hicazHavaYollari}
                        imageTitle="Kâbe-i Muzzama"
                    />
                </div>

                <div>
                    <p className="hajj-subtitle">2. Haccımız</p>
                    <PhotoColumn
                        imageSource={mekkeKapisi}
                        imageTitle="Mekke-i Mükerreme Kapısı"
                        figcaptionFirstTitle="Mekke-i Mükerreme Kapısı"
                        className="red-caption"
                    />
                </div>

                <div>
                    <p className="hajj-subtitle">3. Haccımız</p>
                    <PhotoColumn
                        imageSource={kabe}
                        imageTitle=""
                        figcaptionFirstTitle="Kâbe-i Muazzama"
                        className="red-caption"
                    />
                </div>
                <div>
                    <p className="hajj-subtitle">4. Haccımız</p>
                    <PhotoColumn
                        imageSource={kabePanorama}
                        imageTitle=""
                    />
                </div>
                <div>
                    <p className="hajj-subtitle">5. Haccımız</p>
                    <PhotoColumn
                        imageSource={ilkZemzemKuyusu}
                        imageTitle="Zemzem Kuyusu"
                        figcaptionFirstTitle="Hz. Hacer’e ikram olunan zemzemin ilk zuhurunu temsil eden resim."
                        className="red-caption"
                    />
                </div>
                <div >
                    <p className="hajj-subtitle">6. Haccımız</p>
                    <PhotoColumn
                        imageSource={makamiIbrahimAll}
                        imageTitle=""
                    />
                    <div className="makami-ibrahim">
                        <PhotoColumn
                            imageSource={kitabe}
                            imageTitle="Makam-ı İbrahim"
                            figcaptionFirstTitle="Hz. İbrahim (A.S.)’ın Kâbbe’nin bina edilişi sırasında bastığı taş ve üzerindeki ayak izleri (Makam-ı İbrahim)."
                            figcaptionColor="#e30b17"
                            figcaptonFontWeight={"bold"}
                        />
                    </div>
                </div>
                <div>
                    <p className="hajj-subtitle">7. Haccımız</p>
                    <PhotoColumn
                        imageSource={mikatMahali}
                        imageTitle=""
                        figcaptionFirstTitle="Mikat Mahali"
                        className="red-caption"
                    />
                </div>
                <div>
                    <p className="hajj-subtitle">8. Haccımız</p>
                    <PhotoColumn
                        imageSource={tavafBaslangicNoktasi}
                        imageTitle=""

                    />
                </div>
                <div>
                    <p className="hajj-subtitle">9. Haccımız</p>
                    <PhotoColumn
                        imageSource={kabeSaftlar}
                        imageTitle="Kâbe Şavtlar"
                        figcaptionFirstTitle="Kâbe’nin tavafında yedi şavtın uygulanışını gösteren şema."
                        className="red-caption"
                    />
                </div>
                <div>
                    <p className="hajj-subtitle">10. Haccımız</p>
                    <PhotoColumn
                        imageSource={multezemKapisi}
                        imageTitle="Kâbe-i Muazzama Mültezem Kapısı"
                        figcaptionFirstTitle="Kâbe-i Muazzama Mültezem Kapısı"
                        className="red-caption"
                    />
                </div>
                <div>
                    <p className="hajj-subtitle">11. Haccımız</p>
                    <PhotoColumn
                        imageSource={safaTepesi}
                        imageTitle=""
                        figcaptionFirstTitle="Şüphesiz Safâ ve Merve, Allah’ın sembollerindendir.(Bakara, 158)"
                        figcaptionSecondTitle="Say’in başlandığı yer, Safa tepesi."
                        className="red-caption"
                    />
                </div>
                <div>
                    <p className="hajj-subtitle">12. Haccımız</p>
                    <PhotoColumn
                        imageSource={merveTepesi}
                        imageTitle=""
                        figcaptionFirstTitle="Şüphesiz Safâ ve Menve, Allah’ın sembollerindendir. (Bakara, 158)"
                        figcaptionSecondTitle="Say’in bittiği yer, Merve Tepesi."
                        className="red-caption"
                    />
                </div>
                <div>
                    <p className="hajj-subtitle">13. Haccımız</p>
                    <PhotoColumn
                        imageSource={hacerulEsved}
                        imageTitle="Hacer'ül Esved"
                        figcaptionFirstTitle="Hacer'ül Esved"
                        className="red-caption"
                    />
                </div>

                <div>
                    <p className="hajj-subtitle">14. Haccımız</p>
                    <PhotoColumn
                        imageSource={arafat}
                        imageTitle="Arafat Çadırları"
                        figcaptionFirstTitle="Arafat Çadırları"
                        className="red-caption"
                    />
                </div>
                <div>
                    <p className="hajj-subtitle">15. Haccımız</p>
                    <PhotoColumn
                        imageSource={arafatCadirlari}
                        imageTitle="Arafat Çadırları"
                        figcaptionFirstTitle="Arafat Çadırları"
                        className="red-caption"
                    />
                </div>

                <div>
                    <p className="hajj-subtitle">16. Haccımız</p>
                    <PhotoColumn
                        imageSource={babaArafatCadirinda}
                        imageTitle="İlk Haccımızdan Arafat Çadırlarında iken"
                        figcaptionFirstTitle="İlk Haccımızdan Arafat Çadırlarında iken (1977)"
                        className="red-caption"
                    />

                </div>
                <div>
                    <p className="hajj-subtitle">17. Haccımız</p>
                    <PhotoColumn
                        imageSource={muzdelifeCadirlari}
                        imageTitle="muzdelife Çadırları"
                        figcaptionFirstTitle="Müzdelife Çadırları"
                        className="red-caption"
                    />
                </div>
                <div>
                    <p className="hajj-subtitle">18. Haccımız</p>
                    <PhotoColumn
                        imageSource={minaCadirlari}
                        imageTitle="Mina Çadırları"
                        figcaptionFirstTitle="Mina Çadırları"
                        className="red-caption"
                    />
                </div>

                <div style={{ marginBottom: 20 }}>
                    <p className="hajj-subtitle">19. Haccımız</p>

                    <div style={{ display: "flex", alignItems: "center", justifyContent: 'center' }}>

                        <PhotoColumn
                            imageSource={seytanTaslama}
                            imageTitle="Şeytan Taşlama"
                            figcaptionFirstTitle="Şeytan Taşlama"
                            className="red-caption"
                        />
                        <PhotoColumn
                            imageSource={kurban}
                            imageTitle="Hacc Kurbanı"
                            figcaptionFirstTitle="Hacc Kurbanı"
                            className="red-caption"
                        />
                    </div>
                </div>
            </article>
        </section>

    );
}

export default Hajj;